export default `
<style type="text/css">
  p {
    margin: 10px 0;
  }

  .page-container, .main-container {
    max-width: 1024px;
    margin: 0 auto;
    background-color: #ffffff;
  }
  
  .page {
  page-break-before: always;
  }
  
  tr, thead {
    border: none;
  }
  
  .paragraph-headline {
    font-weight: bold;
    text-transform: uppercase;
  }
  
  .small {
    font-size: 11.3px;
  }
  
  .section-title {
    font-weight: bold;
    text-transform: uppercase;
  }
  
  .nav-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  }
  
  .center-content {
  width: 33%;
  text-align: center;
  font-weight: bold;
  }
  
  .primary-content, .secondary-content {
  width: 33%;
  }
  
  .logo-image {
  height: 35px;
  }
  
  .main-container {
    padding: 20px 60px;
  }
  
  .header {
    border-top: solid #000000 2px;
    text-align: center;
  }
  
  .divider {
    background-color: #000000;
    height: 2px;
  }
  
  .price-container {
    font-size: 18px;
    font-weight: bold;
  }
  
  .vehicle-field, .price-container {
    width: 25%;
    padding: 0 0 10px;
  }
  
  .text {
    text-align: start;
    flex: 1;
    margin: 0 10px;
  }
  
  .blank {
    width: 100px;
    border-top: 1px solid #000000;
    display: inline-block;
  }
  
  .square-checkbox {
    height: 25px;
    width: 25px;
    text-align: center;
    line-height: 25px;
    display: inline-block;
    border: 1px solid #000000;
  }
  
  .start-aligned {
    text-align: start;
  }
  
  .guarantees-row {
    padding-bottom: 10px;
    display: flex;
    align-items: center;
  }
  
  .inlined {
    display: inline;
  }
  
  .space-between-content {
    justify-content: space-between;
  }
  
  .end-aligned {
    text-align: end;
  }
  
  .vehicle-info {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
  
  .vehicle-info-field-value {
    display: block;
  }
  
  .vehicle-info-field-label {
    width: 80%;
    display: inline-block;
    border-top: solid #000000 1px;
  }
</style>
`;



// WEBPACK FOOTER //
// ./src/pages/vehicles/style-text.js